module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedMedium.20aeb52.woff";